import * as React from 'react'
import { Typography, TypographyProps } from '@mui/material'

const Text = (props: TypographyProps) => {
    return <Typography {...props}>{props.children}</Typography>
}

export type { TypographyProps as TextProps }

export default Text
